<template>
    <div class="coordMain">
        <div class="coordMain_introduce">
            <div class="coordMain_cen">
                <div class="coordMain_top">
                    <div class="coordMain_left">
                        <h1>
                         <img src="../../assets/imges/coordinates/logo.png"/>
                        </h1>
               
                               <p v-html = 'content'></p>
                    </div>
                    <div class="coordMain_right">
                        <img :src="aboutimg">
                        <!-- <ul class="img1">
                            <li><img src="../../assets/imges/coordinates/rightli1.png"/></li>
                            <li><img src="../../assets/imges/coordinates/rightli2.png"/></li>
                        </ul>
                        <ul class="img2">
                            <li><img src="../../assets/imges/coordinates/rightli3.png"/></li>
                            <li><img src="../../assets/imges/coordinates/rightli4.png"/></li>
                        </ul> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="coordMain_Product">
            <div class="Product_cennert">
                <img src="../../assets/imges/coordinates/gy_play.png"/>
                 <video v-if="bedonevideo" muted  style="object-fit: fill; background: #000000;"  width="100%" height="100%" controls="controls" autoplay="autoplay">
                        <source src="../../../static/v.mp4" type="video/mp4">
                </video>
            </div>
        </div> -->
    </div>
</template>
<script>
export default {
    name:"coord-main",
    data(){
        return{
            bedonevideo:false,
            content:'',
            aboutimg:''
        }
    },
    created(){
        this.getinfo()
    },
    methods:{
        gy_play(){
            this.bedonevideo = true
        },
        
        getinfo(){
            this.$axios.get("https://www.3dyunchuang.com/api/test/getaboutcontent",)
            .then(response => {    
                this.content = response.data.data[0].content
                this.aboutimg = response.data.data[0].cover
            })
                       
        }
    }
}
</script>
<style>
.coordMain_left h1 p{
    line-height: 3px;
    font-size: 18px;
     color: #757575;
     font-weight: normal;
}
.coordMain_left p{
    letter-spacing:1.5px;
    font-size: 16px;
    line-height: 38px;  
}
.p{
    margin-bottom: 20px;
}
</style>
<style scoped>
.coordMain{
    width: 100%;
    height: 680px;
    background: #ffffff;
}
.coordMain_introduce{
    width: 100%;
    height: 604px;
    background: url("../../assets/imges/coordinates/top_bg.png") no-repeat 290px center;
}
.coordMain_cen{
    width: 1202px;
    height: 100%;
    margin: 0 auto;
}
.coordMain_top{
    float: left;
    height: 592px;
    width: 100%;
    margin-top: 70px;
}
.coordMain_left{
    width: 685px;
    height: 100%;
    float: left;

}
.coordMain_left h1{
    width: 186px;
    height: 53px;
    margin-bottom: 25px;
    margin-top: 28px;
}
.coordMain_left h1 p{
    line-height: 3px;
    font-size: 18px;
     color: #757575;
     font-weight: normal;
}
.coordMain_left p{
    letter-spacing:1.5px;
    font-size: 16px;
    line-height: 38px;  
}
.p{
    margin-bottom: 20px;
}
.coordMain_right{
    width: 449px;
    height: 90%;
    float: right;
    padding-top: 32px;
}
.coordMain_right img{
    width: 443px;
}
.coordMain_right li{
    width: 211px;
    height: 210px;
    float: left;
}
.coordMain_right li img{
    width: 100%;
    height: 100%;
}
.img1{
    width: 218px;
    height: 532px;
    float: left;
}
.img1 li:nth-child(1){
    margin-bottom: 24px;
}
.img2{
    width: 218px;
    height: 532px;
    float: right;
}
.img2 li:nth-child(1){
    margin-top: 55px;
    margin-bottom: 24px;
}
.coordMain_Product{
    width: 100%;
    height: 797px;
    background: #f8f8f8;
    margin-top: 90px;
}
.Product_cennert{
    width: 1202px;
    height: 630px;
    margin: 0 auto;
    /* padding-top: 50px; */
}
.Product_cennert img{
    width: 100%;
    /* cursor: pointer; */
}

</style>


// WEBPACK FOOTER //
// src/common/coordinates/coord-main.vue